import type { AgentPermissions } from "@paperclipai/shared";

export type TrustPreset = "standard" | "low_trust_review" | "high_trust";

export function buildPermissionsForTrustPreset(
  _existing: Partial<AgentPermissions> | null,
  preset: TrustPreset,
): Partial<AgentPermissions> {
  switch (preset) {
    case "high_trust":
      return { canCreateAgents: true };
    case "low_trust_review":
      return { canCreateAgents: false };
    case "standard":
    default:
      return { canCreateAgents: false };
  }
}

export function getTrustPreset(permissions: Partial<AgentPermissions>): TrustPreset {
  if (permissions.canCreateAgents) {
    return "high_trust";
  }
  return "standard";
}
